module.exports = __webpack_public_path__ + "static/media/why_ro.3a4850c0.vtt";